import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../utils/i18n';
import './styles/CoachInfo.scss';

const CoachInfo = ({ name, picture }) => (
  <div className="coach-info-wrapper">
    <div className="coach-picture">
      <img src={ picture } alt="" />
    </div>
    <div className="coach-name">{name}</div>
    <div className="coach-label">
      {i18n.t('singleSessionScreen.COACH_LABEL_TEXT')}
    </div>
  </div>
);

CoachInfo.propTypes = {
  name: PropTypes.string,
  picture: PropTypes.string
};

CoachInfo.defaultProps = {
  name: '',
  picture: ''
};

export default CoachInfo;



// WEBPACK FOOTER //
// ./src/components/CoachInfo.js